import { render, staticRenderFns } from "./SalesForcast.vue?vue&type=template&id=1f182e72&scoped=true"
import script from "./SalesForcast.vue?vue&type=script&lang=js"
export * from "./SalesForcast.vue?vue&type=script&lang=js"
import style0 from "./SalesForcast.vue?vue&type=style&index=0&id=1f182e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f182e72",
  null
  
)

export default component.exports